import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Link, useHistory, useParams } from "react-router-dom";
import { useAppUserDetailsSelector, useAppUserTokenSelector } from "src/_common/hooks/selectors/userSelector";
import { useAppCmsListSelector, useAppEventStatusMessageSelector } from "src/_common/hooks/selectors/eventSelector";
import {
  URLS,
  STORAGE,
  SELECTED_EVENT_STORAGE,
  detectDevice,
  IS_SHOWING_ADD_TO_HOME_SCREEN_IOS,
  CRYPTO_SECRET_KEY,
  SOCKET_CHANNEL,
  APPLICATION_GLOBAL_SLUG,
  SOCKET_URL,
  SOCKET_TRANSPORTS,
  SELECTED_PWA_STORAGE,
} from "src/_config";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { RODEO_PAGE_NAME } from "src/_config";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { toast } from "react-toastify";
import UpdateDisplayNameModal from "../events/modal/updateDisplayNameModal";
import { useCmsApi } from "src/_common/hooks/actions/cms/cmsApiHook";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import StatusModal from "../events/modal/statusModal";
import useSocket from "use-socket.io-client";
import CouponModal from "../events/modal/couponModal";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

interface SideBarProps {
  page: string;
}

function Sidebar({ page }: SideBarProps) {
  const userApi = useUserApi();
  const history = useHistory();
  const userDetails = useAppUserDetailsSelector();
  const statusMessageSelector = useAppEventStatusMessageSelector();
  const userAction = useAppUserAction();
  const eventAction = useAppEventAction();
  const eventApi = useEventApi();

  const [isShowIosPopup, setIsShowIosPopup] = useState<any>(
    localStorage.getItem(IS_SHOWING_ADD_TO_HOME_SCREEN_IOS)
      ? parseInt(localStorage.getItem(IS_SHOWING_ADD_TO_HOME_SCREEN_IOS) || "0")
      : 1
  );
  const [showDisplayNameModal, setShowDisplayNameModal] = useState<boolean>(false);
  // const [cmsList, setCmsList] = useState<any>()
  const cmsList = useAppCmsListSelector();
  const { eventId } = useParams<any>();
  const e_id: any = eventId ? parseInt(cryptr.decrypt(eventId)) : null;
  const cmsApi = useCmsApi();
  const [showStatusModal, setShowStatusModal] = useState<boolean>(false);
  const [showCouponModal, setShowCouponModal] = useState<boolean>(false);
  const [couponData, setCouponData] = useState<any>();
  const [appRedirectData, setAppRedirectData] = useState<any>();
  const userToken = useAppUserTokenSelector();
  const urlParams = useParams<any>();

  // const [showHeaderMenu, setShowHeaderMenu] = useState<boolean>(true)
  const toogleSideBarOnOff = (status: boolean) => {
    var sidebarCollapseElement = document.getElementById("sidebarCollapse");
    var sidebarElement = document.getElementById("sidebar");
    var overlayElement = document.getElementById("overlay");
    if (status) {
      if (sidebarCollapseElement) {
        sidebarElement?.classList.add("active");
        overlayElement?.classList.add("active");
      }
    } else {
      if (sidebarCollapseElement) {
        sidebarElement?.classList.remove("active");
        overlayElement?.classList.remove("active");
      }
    }
  };

  // const toogleProfileMenuBarOnOff = () => {
  //   var navbarCollapseElement = document.getElementById("navbarCollapse");
  //   setShowHeaderMenu(!showHeaderMenu)
  //   if (showHeaderMenu) {
  //     if (navbarCollapseElement) {
  //       navbarCollapseElement.classList.add("show")
  //     }
  //   } else {
  //     if (navbarCollapseElement) {
  //       navbarCollapseElement.classList.remove("show")
  //     }
  //   }
  // }

  const getGameDetails = () => {
    let params = {
      slug: APPLICATION_GLOBAL_SLUG,
    };
    eventApi.callGetGameDetails(
      params,
      (message: any, resp: any) => {
        // console.log({resp})
      },
      (message: any) => {}
    );
  };

  const logOut = (e: React.MouseEvent) => {
    userApi.callLogout(
      (message: string, resp: any) => {
        if (resp) {
          toogleSideBarOnOff(false);
          userAction.logout();
          // localStorage.removeItem(STORAGE)
          // localStorage.removeItem(SELECTED_EVENT_STORAGE)
          history.push(URLS.HOME);
        } else {
          // toast.error(message)
        }
      },
      (message: string) => {
        userAction.logout();
        // toast.error(message)
      }
    );
    localStorage.removeItem(STORAGE);
    localStorage.removeItem(SELECTED_EVENT_STORAGE);
  };

  const goToHome = () => {
    history.push(URLS.HOME);
  };

  const closeIosPopup = (e: any) => {
    e.preventDefault();
    setIsShowIosPopup(0);
    localStorage.setItem(IS_SHOWING_ADD_TO_HOME_SCREEN_IOS, "0");
  };

  const getCmsList = () => {
    let params = {
      game_id: cryptr.decrypt(eventId),
    };

    cmsApi.callGameCms(
      params,
      (message: string, resp: any) => {
        // if (resp && resp.list && resp.list.length) {
        eventAction.setCmsList(resp.list);
        // }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const onStatusModalClose = () => {
    setShowStatusModal(false);
  };

  const onCouponModalClose = () => {
    setShowCouponModal(false);
  };

  const onStatusModalSuccess = () => {
    if (appRedirectData) {
      setShowStatusModal(false);
      let link = appRedirectData.game_info.pwa_link;
      if (link) {
        setTimeout(() => {
          window.open(
            link +
              (appRedirectData?.rodeo_event_id && userToken
                ? `#token=${cryptr.encrypt(appRedirectData.rodeo_event_id)}&userToken=${userToken}`
                : appRedirectData?.rodeo_event_id
                ? `#token=${cryptr.encrypt(appRedirectData.rodeo_event_id)}`
                : userToken
                ? `#userToken=${userToken}`
                : ""),
            "_blank"
          );
        }, 500);
      }
    }
  };

  const gotoCmsPage = (id: any) => {
    history.push(`/cms/${eventId}/${cryptr.encrypt(id)}`);
  };

  const onPageChange = () => {
    if (userDetails && !userDetails.display_name) {
      console.log({ userDetails });
      setShowDisplayNameModal(true);
    }
  };

  const goToLeaderBoardPage = () => {
    history.push({
      pathname: URLS.EVENT.LEADERBOARD,
      state: { id: e_id },
    });
  };

  const gotoLogin = () => {
    localStorage.removeItem(SELECTED_PWA_STORAGE);
    localStorage.removeItem("gameSlug");
    history.push(URLS.LOGIN);
  };

  useEffect(() => {
    onPageChange();
    getGameDetails();
  }, []);

  useEffect(() => {
    if (eventId) {
      getCmsList();
    } else {
      eventAction.setCmsList(null);
    }
  }, [eventId]);

  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true,
    transports: SOCKET_TRANSPORTS,
    upgrade: true,        // Enable transport upgrades (polling -> websocket)
    rememberUpgrade: true, // Remember successful upgrades for faster reconnection
  });

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.APP_REDIRECT, (data: any) => {
      if (data.game_info.slug != APPLICATION_GLOBAL_SLUG) {
        console.log({ data });
        setShowStatusModal(true);
        setAppRedirectData(data);
      }
    });

    socket.on(SOCKET_CHANNEL.STATUS_MSG, (changeEventStatus: any) => {
      console.log("OuStatusChange>>>>>>>>>>", changeEventStatus);
      // if(changeEventStatus?.rodeo_event_id && urlParams?.eventId && changeEventStatus?.rodeo_event_id==cryptr.decrypt(urlParams?.eventId)) {
      if (changeEventStatus.site == APPLICATION_GLOBAL_SLUG) {
        eventAction.getStatusMessage(changeEventStatus);
      }
      // }
    });

    socket.on(SOCKET_CHANNEL.COUPON, (data: any) => {
      console.log({ data });
      setCouponData(data);
      setShowCouponModal(true);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    console.log({ statusMessageSelector });
  }, [statusMessageSelector]);

  useEffect(() => {
    if (userToken) {
      userApi.callCheckValidToken(
        (message: any, resp: any) => {
          console.log(1, { resp });
          if (!resp) {
            console.log(2, { resp });
            userAction.logout();
          }
        },
        (message: any, resp: any) => {
          console.log(3, { resp });
          userAction.logout();
        }
      );
    }
  }, [page]);

  return (
    <section className="top-nav">
      {/*LEFT MENU*/}
      {/*Navbar*/}
      <nav
        id="sidebar"
        className="mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        style={{ overflow: "visible" }}
      >
        <div id="dismiss" onClick={() => toogleSideBarOnOff(false)}>
          <i className="fa fa-arrow-left" />
        </div>
        <div className="sidebar-header">
          <img src="/images/logo.png" alt="Inside Rodeo" /> Inside Rodeo
        </div>
        {userDetails && (
          <div className="head-user">
            {/* Welcome, {userDetails && userDetails.full_name && userDetails.full_name !== " " ? userDetails.full_name : ' User'} */}
            Welcome,{" "}
            {userDetails && userDetails.first_name && userDetails.last_name
              ? userDetails.first_name + " " + userDetails.last_name
              : " User"}
          </div>
        )}
        <ul className="list-unstyled components">
          <li>
            <Link to={URLS.HOME}>Rodeo Events</Link>
          </li>
          {/* {
            userDetails &&
            <li>
              <Link to={URLS.USER.PROFILE}>My Profile</Link>
            </li>
          } */}
          {userDetails ? (
            <li>
              <Link to={URLS.USER.PROFILE}>My Profile</Link>
            </li>
          ) : (
            <li>
              {/* <Link to={URLS.LOGIN}>Login</Link> */}
              <a onClick={gotoLogin}>Login</a>
            </li>
          )}
          {/* <li>
            <Link to={URLS.CMS.ABOUT_US}>About Us</Link>
          </li>
          <li>
            <Link to={URLS.CMS.LEGAL}>Legal</Link>
          </li> */}
          {cmsList && cmsList.length
            ? cmsList.map((cms: any) => (
                <li key={cms.id}>
                  <a onClick={() => gotoCmsPage(cms.id)}>{cms.title}</a>
                </li>
              ))
            : null}
          <li>
            <a href="https://games.insiderodeo.com" target="_blank">
              Contact Us
            </a>
          </li>
          {userDetails ? (
            <li>
              <Link to="#" onClick={(e) => logOut(e)}>
                Logout
              </Link>
            </li>
          ) : null}
        </ul>
      </nav>
      <nav className="navbar navbar-light">
        <div className="container-fluid">
          <div className="top-nav-inner">
            <button type="button" id="sidebarCollapse" className="btn-none">
              <span className="open-nav" onClick={() => toogleSideBarOnOff(true)}>
                <img src="/images/menu.svg" alt="menu" />
              </span>
            </button>
            {
              // userDetails &&
              <button
                className="navbar-toggler btn-none d-inline-block ml-auto user-image"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
                // onClick={toogleProfileMenuBarOnOff}
                onClick={goToHome}
              >
                <img src="/images/logo.png" alt="User" />
              </button>
            }
            {/* <div className='top-marquee-text'>
            <Marquee direction="left" loop={0} pauseOnHover={true} speed={60}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sodales eros quis tortor mollis, non suscipit dui molestie. Sed facilisis, metus nec suscipit varius, dolor erat dapibus libero, id porttitor ipsum turpis non enim. Donec blandit vitae lorem quis sollicitudin. Sed ornare diam vitae purus cursus cursus.
            </Marquee>
          </div> */}
            {[RODEO_PAGE_NAME.EVENT_GAME_LIST, RODEO_PAGE_NAME.EVENT_GAME_DETAILS].includes(page) &&
              // statusMessageSelector && statusMessageSelector.status_text &&
              statusMessageSelector &&
              statusMessageSelector.length && (
                // <div className="status-bar-wrap">
                <>
                  <div className="top-marquee-text">
                    <Marquee direction="left" loop={0} pauseOnHover={true} speed={60}>
                      {statusMessageSelector}
                    </Marquee>
                  </div>
                  {/* <div className='leader-board-btn-inner'
                onClick={() => {goToLeaderBoardPage()}}
              >
                <span>Leader board</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                <path d="M14.1749 4.29318C14.404 4.23806 14.6424 4.25001 14.8769 4.24935C16.4049 4.25201 17.9322 4.24869 19.4602 4.25068C20.0233 4.23673 20.5672 4.59599 20.7824 5.11462C20.9324 5.44865 20.8913 5.82185 20.8959 6.17712C20.8959 13.5489 20.8959 20.9206 20.8959 28.2924C20.9132 28.8476 20.5765 29.3927 20.0678 29.6192C19.7551 29.7746 19.3971 29.7507 19.0585 29.7507C17.6639 29.75 16.2701 29.7493 14.8762 29.7507C14.5588 29.7533 14.2254 29.7646 13.9332 29.6205C13.4265 29.3934 13.0852 28.8515 13.1038 28.2957C13.1038 20.7652 13.1038 13.2354 13.1038 5.70564C13.0779 5.06017 13.5474 4.44259 14.1749 4.29318Z" fill="white"/>
                <path d="M3.87871 12.7998C4.0434 12.7547 4.21539 12.75 4.38539 12.7487C5.99973 12.7533 7.61473 12.746 9.22973 12.752C9.96883 12.744 10.6289 13.4035 10.6223 14.1419C10.6263 18.88 10.6269 23.6187 10.6223 28.3568C10.6289 29.0933 9.97215 29.7513 9.2357 29.7474C7.57355 29.7527 5.91074 29.75 4.24859 29.7487C3.50219 29.7653 2.82684 29.1032 2.83547 28.3555C2.83082 23.6413 2.83481 18.9271 2.83281 14.2129C2.80426 13.5741 3.26047 12.9605 3.87871 12.7998Z" fill="white"/>
                <path d="M24.3942 15.6407C24.6678 15.5616 24.9554 15.5855 25.2363 15.5829C26.674 15.5829 28.1123 15.5849 29.55 15.5816C29.8103 15.5789 30.0799 15.5902 30.3197 15.7044C30.8237 15.9216 31.1717 16.4515 31.165 17.0013C31.167 20.7858 31.169 24.5703 31.1644 28.3548C31.171 29.1012 30.4996 29.7633 29.7539 29.7487C28.1143 29.752 26.4747 29.7493 24.8352 29.75C24.2674 29.7706 23.7136 29.4173 23.4924 28.8947C23.355 28.6032 23.3736 28.2725 23.3742 27.9584C23.3769 24.3054 23.3729 20.6517 23.3762 16.998C23.3663 16.3851 23.8065 15.806 24.3942 15.6407Z" fill="white"/>
                </svg>
              </div> */}
                </>
              )}
          </div>
        </div>
      </nav>
      <div className="overlay" id="overlay" onClick={() => toogleSideBarOnOff(false)} />
      {/* IOS Scrren Add to home scrren option popup */}
      {
        // detectDevice() && isShowIosPopup ?
        //   <>
        //     < div className="bottom_fixedsec">
        //       <div className="mid-sec">
        //         <h2>To add this Instant app to the home screen: tap <span className="share-x-icon" /> and then Add to Home Screen.</h2>
        //       </div>
        //       <div className="icon_div_right">
        //         <a href="#" onClick={(e) => closeIosPopup(e)}>
        //           <svg className="svg-inline--fa fa-times-circle fa-w-16" aria-hidden="true" data-prefix="fa" data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg>
        //             <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
        //           </svg>
        //         </a>
        //       </div>
        //     </div>
        //   </> : null
      }
      {showStatusModal && appRedirectData && (
        <StatusModal
          shouldShow={showStatusModal}
          onClose={onStatusModalClose}
          onSuccess={onStatusModalSuccess}
          message={appRedirectData?.message}
          type={2}
        />
      )}
      {showDisplayNameModal && (
        <UpdateDisplayNameModal onClose={() => setShowDisplayNameModal(false)} shouldShow={showDisplayNameModal} />
      )}
      {showCouponModal &&
        couponData &&
        couponData.image &&
        (couponData.type == 1 || (couponData.type == 2 && userDetails && userDetails.id)) && (
          <CouponModal shouldShow={showCouponModal} onClose={onCouponModalClose} image={couponData.image} />
        )}
    </section>
  );
}

export default Sidebar;
